import { render, staticRenderFns } from "./stock-edit.vue?vue&type=template&id=9ef9b47c&scoped=true&"
import script from "./stock-edit.vue?vue&type=script&lang=js&"
export * from "./stock-edit.vue?vue&type=script&lang=js&"
import style0 from "./stock-edit.vue?vue&type=style&index=0&id=9ef9b47c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ef9b47c",
  null
  
)

export default component.exports